import { render } from "./ReserveLocker.vue?vue&type=template&id=65b0d6bc&ts=true"
import script from "./ReserveLocker.vue?vue&type=script&lang=ts"
export * from "./ReserveLocker.vue?vue&type=script&lang=ts"

import "./ReserveLocker.vue?vue&type=style&index=0&id=65b0d6bc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__